import { get } from '..';
import { applySolveAnalyticsFilters, GetSolveAnalyticsStatsProps } from './Utils';

const GetPriorityStats = (props: GetSolveAnalyticsStatsProps) => {
  const baseUrl: string = 'solve-analytics/tickets/priority-statistics';
  const url: string = applySolveAnalyticsFilters(baseUrl, props);
  return get(url);
};

export default GetPriorityStats;
